import React, { useEffect, useState } from "react";
import FeaturedIcon from "../../CommonComponents/FeaturedIcon";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useAuth from "../../../Hooks/useAuth";
import { RESULT_STATUS } from "../../../constants";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import { LibraryContext } from "../../../context/LibraryContext";

const STATS = [
  {
    id: 1,
    key: "easy_count",
    title: "Easy",
    icon: (
      <FeaturedIcon
        icon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.0833 0 12.1083 0.158333 13.075 0.475C14.0417 0.791667 14.9333 1.23333 15.75 1.8L14.3 3.275C13.6667 2.875 12.9917 2.5625 12.275 2.3375C11.5583 2.1125 10.8 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 12.2167 2.77917 14.1042 4.3375 15.6625C5.89583 17.2208 7.78333 18 10 18C12.2167 18 14.1042 17.2208 15.6625 15.6625C17.2208 14.1042 18 12.2167 18 10C18 9.7 17.9833 9.4 17.95 9.1C17.9167 8.8 17.8667 8.50833 17.8 8.225L19.425 6.6C19.6083 7.13333 19.75 7.68333 19.85 8.25C19.95 8.81667 20 9.4 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM8.6 14.6L4.35 10.35L5.75 8.95L8.6 11.8L18.6 1.775L20 3.175L8.6 14.6Z"
              fill="#12B76A"
            />
          </svg>
        }
        color="success"
      />
    ),
    borderLeft: "4px solid #32D583",
  },
  {
    id: 2,
    key: "medium_count",
    title: "Medium",
    icon: (
      <FeaturedIcon
        icon={
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 18V16L2 14V18H0ZM4 18V12L6 10V18H4ZM8 18V10L10 12.025V18H8ZM12 18V12.025L14 10.025V18H12ZM16 18V8L18 6V18H16ZM0 12.825V10L7 3L11 7L18 0V2.825L11 9.825L7 5.825L0 12.825Z"
              fill="#F96343"
            />
          </svg>
        }
        color="primary"
      />
    ),
    borderLeft: "4px solid #F79009",
  },
  {
    id: 3,
    key: "hard_count",
    title: "Hard",
    icon: (
      <FeaturedIcon
        icon={
          <svg
            width="18"
            height="21"
            viewBox="0 0 18 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 2V0H12V2H6ZM8 13H10V7H8V13ZM9 21C7.76667 21 6.60417 20.7625 5.5125 20.2875C4.42083 19.8125 3.46667 19.1667 2.65 18.35C1.83333 17.5333 1.1875 16.5792 0.7125 15.4875C0.2375 14.3958 0 13.2333 0 12C0 10.7667 0.2375 9.60417 0.7125 8.5125C1.1875 7.42083 1.83333 6.46667 2.65 5.65C3.46667 4.83333 4.42083 4.1875 5.5125 3.7125C6.60417 3.2375 7.76667 3 9 3C10.0333 3 11.025 3.16667 11.975 3.5C12.925 3.83333 13.8167 4.31667 14.65 4.95L16.05 3.55L17.45 4.95L16.05 6.35C16.6833 7.18333 17.1667 8.075 17.5 9.025C17.8333 9.975 18 10.9667 18 12C18 13.2333 17.7625 14.3958 17.2875 15.4875C16.8125 16.5792 16.1667 17.5333 15.35 18.35C14.5333 19.1667 13.5792 19.8125 12.4875 20.2875C11.3958 20.7625 10.2333 21 9 21ZM9 19C10.9333 19 12.5833 18.3167 13.95 16.95C15.3167 15.5833 16 13.9333 16 12C16 10.0667 15.3167 8.41667 13.95 7.05C12.5833 5.68333 10.9333 5 9 5C7.06667 5 5.41667 5.68333 4.05 7.05C2.68333 8.41667 2 10.0667 2 12C2 13.9333 2.68333 15.5833 4.05 16.95C5.41667 18.3167 7.06667 19 9 19Z"
              fill="#D92D20"
            />
          </svg>
        }
        color="error"
      />
    ),
    borderLeft: "4px solid #F04438",
  },
  {
    id: 4,
    key: "total_count",
    title: "Total",
    icon: (
      <FeaturedIcon
        className="library-stats-total-count-icon"
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="#363F72"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
        color="error"
      />
    ),
    borderLeft: "4px solid #4E5BA6",
  },
];

const LibraryStats = () => {
  const axios = useAxiosPrivate();
  const { setShowNotify } = useAuth();
  const { type } = useParams();
  const { topics } = useContext(LibraryContext);
  const [statsCount, setStatsCount] = useState({});

  useEffect(() => {
    const controller = new AbortController();
    const fetchStats = async () => {
      try {
        // console.log("fetchStats", fetchStats);
        const { data } = await axios.get(
          `node/admin/library/overview?type=${type}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            signal: controller.signal,
          },
        );
        if (data.resultCode === RESULT_STATUS.SUCCESS) {
          setStatsCount({
            easy_count: data.data.easy_count,
            hard_count: data.data.hard_count,
            medium_count: data.data.medium_count,
            total_count: data.data.easy_count + data.data.medium_count + data.data.hard_count
          });
        } else throw new Error("Unable to fetch the library overview");
      } catch (error) {
        let isUnAuth = error?.response?.status === 403;
        if (error?.name === "CanceledError" || error?.name === "AbortError")
          return;
        setShowNotify({
          show: true,
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : "Unable to fetch the library overview. Please try again later",
          title: isUnAuth ? "Warning !" : "Error !",
          isUnAuth,
        });
      }
    };
    fetchStats();
    return () => controller.abort();
  }, [axios, setShowNotify, type, topics]);

  return (
    <div className="library-stats-container">
      {STATS.map((stat) => (
        <div
          className="library-stats"
          key={stat.id}
          style={{ borderLeft: stat.borderLeft }}
        >
          {stat.icon}
          <div className="library-stats-detail-section">
            {stat.title}
            <span className="library-stats-count">
              {statsCount[stat.key] || 0}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LibraryStats;
